<template>

  <div>

    <base-header type="info" class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">{{this.$store.getters.getUser}}
            Dashboard</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <!--          <div class="col-lg-6 col-5 text-right">-->
        <!--            <base-button size="sm" type="neutral">New</base-button>-->
        <!--            <base-button size="sm" type="neutral">Filters</base-button>-->
        <!--          </div>-->
      </div>

    </base-header>
    <div v-if="this.$store.getters.getHaveAccount" class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <card>
            <endorse-linked-in-profile/>
          </card>
        </div>
      </div>
    </div>
    <div v-else class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <card>
           <add-user-credentials/>
          </card>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import EndorseLinkedInProfile from "../../components/ysy/EndorseLinkedInProfile";
    import RouteBreadCrumb from '../../components/Argon/Breadcrumb/RouteBreadcrumb';
    import addUserCredentials from "../../components/addUserCredentials";

    export default {
        name: 'userProfile',
        components: {
            addUserCredentials,
            EndorseLinkedInProfile,
            RouteBreadCrumb
        },
    };
</script>

